/**
 * Parse links element for softcrop link elements
 *
 * @param {object} linksEl
 * @return {Array}
 */
export function importSoftcropLinks(linksEl) {
    if (!linksEl || linksEl.length <= 0) {
        return []
    }

    const crops = []
    linksEl.children.forEach(function(link) {
        if (link.attr('type') !== 'x-im/crop') {
            return
        }

        const parsed = link.attr('uri').match(/im:\/\/crop\/(.*)/)
        if (!Array.isArray(parsed) || parsed.length !== 2) {
            return
        }

        let [x, y, w, h] = parsed[1].split('/')
        crops.push({
            name: link.attr('title'),
            x,
            y,
            width: w,
            height: h
        })
    })

    return crops
}

/**
 * Append softcrop link elements based on crop data
 *
 * @param {object} $$
 * @param {array}  crops Array of soft crops
 * @returns {array}
 */
export function exportSoftcropLinks($$, crops) {
    // <link rel="crop" type="x-im/crop" title="16:9" uri="im://crop/0.07865168539325842/0.0899/0.8426966292134831/0.9899" />
    return crops.map((crop) => {
        const uri = `im://crop/${crop.x}/${crop.y}/${crop.width}/${crop.height}`
        return $$('link').attr({
            title: crop.name,
            rel: 'crop',
            type: 'x-im/crop',
            uri
        })
    })
}
